import { createAction } from '@reduxjs/toolkit';

export const initialize = createAction('app/initialize');
